import { createSelector } from 'reselect'

import { selectLandingState } from './selectLandingState'

export const selectLandingPlannings = createSelector(
  [selectLandingState],
  ({ plannings }) => plannings
)
